import { VIDEO_VARIANTS, VIMEO_EMBED_TEMPLATE, VIMEO_REPLACE_PATTERN } from '@workspace/constants';

import { AppVideoImage, Picture } from '@workspace/ui/common';
import { MediaRendererProps } from '../content-carousel.types';
import { cn } from '@workspace/lib';

const getVimeoEmbedUrl = (videoUrl?: string): string | null => {
  if (!videoUrl) return null;
  const match = videoUrl.match(VIMEO_REPLACE_PATTERN);
  if (!match || !match[1]) return null;
  return `https://${VIMEO_EMBED_TEMPLATE.replace('$1', match[1])}?autoplay=1&muted=1&controls=0&loop=1&background=1`;
};

export function ContentCarouselMediaRenderer({
  slide,
  isActive,
  imageDimensions,
  videoDimensions,
}: MediaRendererProps) {
  const vimeoEmbedUrl = getVimeoEmbedUrl(slide.vimeoURL);

  const dimensions = slide.isVideo && vimeoEmbedUrl ? videoDimensions : imageDimensions;
  const shouldShowVideo = slide.isVideo && vimeoEmbedUrl;
  const image = slide.image || null;

  return (
    <div
      key={slide._key}
      className={cn(
        'absolute inset-0 transition-opacity duration-500 ease-in-out',
        isActive ? 'opacity-100' : 'opacity-0 pointer-events-none',
      )}
      aria-hidden={!isActive}
    >
      {shouldShowVideo ? (
        <AppVideoImage
          video={vimeoEmbedUrl}
          variant={VIDEO_VARIANTS.VideoWithoutText}
          wrapperClassName="!w-full !h-full"
        />
      ) : image?.url ? (
        <Picture
          image={image}
          alt={image.bynderImage?.alt || image.alt || 'Product image'}
          desktopWidth={dimensions.width}
          desktopHeight={dimensions.height}
          mobileWidth={390}
          mobileHeight={260}
          imgClassName="w-full h-full object-cover"
        />
      ) : (
        <div className="text-gray-400 text-center h-full w-full flex flex-col items-center justify-center bg-light-silver" />
      )}
    </div>
  );
}
